import styled from "@emotion/styled"
import React from 'react'
import { Colors } from '../../styles/colors'
import { Spacing } from '../../styles/spacing'

import { Typography } from '../../styles/typography'
import { helpCenterName } from '../../utils/blog/const'
import { stringToSlug } from '../../utils/blog/utils'
import ArrowIcon from '../../icons/left-arrow.svg'
import { SiteLink } from '../SiteLink'

const ListContainer = styled.div`
  flex-basis: 474px;
  max-width: 474px;
  margin-bottom: 40px;
  background-color: white;
  overflow: hidden;
  display: flex;
  transition: 0.1s all;
  .article-title {
    height: 54px;
    text-overflow: ellipsis;
    margin-bottom: 4px;
    overflow: hidden;
    ${Typography.paragraph.p1_700}
    ${Colors.Color.eerieBlack800}

  }
  .article-description {
    height:  48px;
    text-overflow: ellipsis;
    overflow: hidden;
    ${Typography.paragraph.p2_400}
    ${Colors.Color.eerieBlack800}
  }
  .icon-container {
    position: relative;
    right:0;
    top: 23px;
  }
  :hover, :active {
    transform: scale(0.96);

  }
`

export const ArticleListItem = ({ article = {}, collection}) => {
  const { title, description} = article

  return <SiteLink to={`/${helpCenterName}/${article.slug}`} internal name={article.title}>
    <ListContainer>
      <div css={[Spacing.Padding.right_16, Spacing.Flex.flex_1]}>
        <div className={"article-title"}>{title}</div>
        <div className={"article-description"}>{description}</div>
      </div>
      <div className={'icon-container'}><ArrowIcon/></div>

    </ListContainer>

  </SiteLink>
}

